<template>
  <div>
    <el-dialog :title="'指纹采集'" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false"
      @closed="handleDialogClose" center>
      <div class="content">
        <div class="collection" v-if="feature">
          <img src="@/assets/img/success.svg" alt="">
          <div class="text">{{ text }}</div>
        </div>
        <div class="collection" v-else>
          <img src="@/assets/img/fingerprint.svg" alt="">
          <div class="text">{{ text }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="!feature" @click="fingerprintEnroll">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  data() {
    return {
      dialogVisible: false,
      logs: [],
      isConnecting: false,//是否正在连接
      isEnrolling: false,//是否正在采集
      handle: null,//指纹设备句柄
      lastStateCode: -1,//上一次采集状态码
      text: '请将手指放在识别器上进行指纹采集',
      feature: '',//指纹特征
    };
  },
  methods: {
    // 打开弹窗时初始化
    openDialog() {
      this.dialogVisible = true;
      this.startEnroll()
      console.log(this.handle)

    },

    // 弹窗关闭时清理
    handleDialogClose() {

    },
    // 添加日志
    addLog(message, type = 'info') {
      const now = new Date()
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`
      this.logs.push({
        time: timeStr,
        message: message,
        type: type
      })
      // 保持滚动到底部
      setTimeout(() => {
        const consoleEl = document.querySelector('.console')
        if (consoleEl) {
          consoleEl.scrollTop = consoleEl.scrollHeight
        }
      }, 10)
    },
    clearLog() {
      this.logs = []
    },
    startEnroll() {
      this.addLog('指纹服务开始连接...', 'info')

      this.feature = ''
      this.isConnecting = true

      Fp.connect(() => {
        this.addLog('指纹服务连接成功', 'success')
        this.text = '指纹服务连接成功'

        Fp.setDeviceType(Fp.SERIAL_DEVICE, () => {
          Fp.openDevice(-1, (returnObj) => {
            this.handle = returnObj.handle
            if (this.handle > 0) {
              this.addLog('设备打开成功', 'success')
              this.isConnecting = false
              this.isEnrolling = true
              this.enrolling(this.handle)
            } else {
              this.addLog('设备打开失败', 'error')
              this.text = '设备打开失败'
              this.isConnecting = false
            }
          })
        })
      }, (jqXHR, textStatus, errorThrown) => {
        this.addLog(`连接失败 - ${textStatus}: ${errorThrown}`, 'error')
        this.isConnecting = false
      })
    },
    stopEnroll() {
      this.isEnrolling = false
      this.addLog('注册任务已取消', 'warning')
      if (this.handle && this.handle > 0) {
        Fp.closeDevice(this.handle, (returnObj) => {
          if (returnObj.retCode == Fp.RT_SUCCESS) {
            this.addLog('设备已关闭', 'success')
          }
        })
      }
    },
    enrolling(handle) {
      if (!this.isEnrolling) return

      Fp.enroll(handle, (returnObj) => {
        const stateCode = returnObj.stateCode

        if (stateCode == Fp.RT_SUCCESS) {
          this.addLog(`特征大小: ${returnObj.featureLen}, 特征: ${returnObj.feature}`, 'success')
          this.feature = returnObj.feature
          Fp.closeDevice(handle, (returnObj) => {
            if (returnObj.retCode == Fp.RT_SUCCESS) {
              this.addLog('设备已关闭', 'success')
              this.text = '指纹采集成功'
              this.isEnrolling = false
            }
          })
        } else if (stateCode == Fp.RT_FP_CANCEL) {
          this.addLog('注册任务已取消', 'warning')
          this.isEnrolling = false
        } else {
          if (this.lastStateCode != stateCode) {
            this.lastStateCode = stateCode
            this.handleStateCode(stateCode)
          }

          Fp.sleep(200)
          this.enrolling(handle)
        }
      })
    },
    handleStateCode(stateCode) {
      switch (stateCode) {
        case Fp.RT_NEED_FIRST_SWEEP:
          this.addLog('##请按第一次手指', 'info')
          this.text = '请将手指放在识别器上进行指纹采集'

          break
        case Fp.RT_NEED_SECOND_SWEEP:
          this.addLog('##请按第二次手指', 'info')
          this.text = '请按第二次手指'
          break
        case Fp.RT_NEED_THIRD_SWEEP:
          this.addLog('##请按第三次手指', 'info')
          this.text = '请按第三次手指'
          break
        case Fp.RT_NEED_RELEASE_FINGER:
          this.addLog('##请移开手指', 'info')
          this.text = '请移开手指'
          break
        case Fp.RT_BAD_QUALITY:
          this.addLog('##指纹质量差，请重试', 'warning')
          this.text = '指纹质量差，请重试'
          break
      }
    },
    // 指纹采集
    fingerprintEnroll() {
      this.$api.roleApi.fingerprintEnroll({
        template: this.feature
      }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
      })
    }

  },

}
</script>

<style lang="scss" scoped>
.content {
  margin: 20px 30px 40px;


  .collection {
    text-align: center;

    .text {
      margin-top: 20px;
      font-size: 16px;
      color: #333;
    }
  }
}

/deep/ .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #D8D8D8;
}
</style>